// extracted by mini-css-extract-plugin
export var divider = "_qr-0";
export var systemMessage = "_qr-1";